import { createContext, useReducer } from 'react'

import { CHG } from 'tools/Input2'
import { R_NOTIFY } from 'tools/Notify/reducer'
import { DEFAULT_QUERYS } from 'utils/querys'

import { R_SIGNON } from 'app/Auth/lib'
import { normalizeUserParam } from 'libreon/User/lib'
// import { strcmp } from 'utils/string'
import {
  BASE_R_GLOBAL,
  baseGlobalReducer,
  generateBaseGlobalState,
  resetBaseGlobalState
} from 'reducer/global/base'

function generateSiteState() {
  return {
    ...DEFAULT_QUERYS
  }
}

const defaultState = generateBaseGlobalState(generateSiteState())

function resetGlobalState(oldState, seeds) {
  return resetBaseGlobalState(oldState, seeds || generateSiteState())
}

// function navChallenge(list, key, value) {
//   return list.map((item) => {
//     if (item.label === key) {
//       return { ...item, challenge: value }
//     }
//     return item
//   })
// }

const R_GLOBAL = Object.freeze({
  ...BASE_R_GLOBAL,
  SET_SAVING: 11000,
  TAGS_SET: 12000,
  PREFS_SET: 13000,
  PREFS_READY: 14000,
  NAV_CHALLENGE: 15000,
  UPDATE_QUERY: 17000
  // start local addons after 10k+
})

function reducer(state, args) {
  switch (args.type) {
    case R_GLOBAL.SET_SAVING: {
      const { uuid, status } = args.value
      const savingKeys = { ...state.savingKeys }
      if (status === CHG.OK || status === CHG.SAVED) {
        delete savingKeys[uuid]
      } else {
        savingKeys[uuid] = status
      }
      const saving = Object.keys(savingKeys).length > 0
      return { ...state, saving, savingKeys }
    }

    case R_GLOBAL.TAGS_SET:
      return {
        ...state,
        user: {
          ...state.user,
          profile: args.value,
          ...normalizeUserParam('profile', args.value)
        }
      }

    case R_GLOBAL.PREFS_SET: {
      const prefs = {
        ...state.prefs,
        [args.key]: { ...state.prefs[args.key], ...args.value }
      }
      // cookies.set(COOKIE_NAME, prefs, { path: '/' })
      return { ...state, prefs: { ...prefs, skip: true } }
    }

    case R_GLOBAL.PREFS_READY:
      return { ...state, prefs: { ...state.prefs, skip: false } }

    // case R_GLOBAL.NAV_CHALLENGE: {
    //   let { menu, bar, value } = args
    //   if (menu) {
    //     menu = navChallenge(state.nav.menu, menu, value)
    //     return { ...state, nav: { ...state.nav, menu } }
    //   }
    //   bar = navChallenge(state.nav.bar, bar, value)
    //   return { ...state, nav: { ...state.nav, bar } }
    // }

    case R_GLOBAL.UPDATE_QUERY:
      const { type, ...action } = args
      return { ...state, querys: Object.freeze(action) }

    default:
      return baseGlobalReducer(state, args)
  }
}

const GlobalContext = createContext(null)
function GlobalProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, defaultState)
  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalContext
export {
  R_GLOBAL,
  R_SIGNON,
  R_NOTIFY,
  GlobalProvider,
  resetGlobalState,
  GlobalContext
}
